export default class AnimationOnScroll {
    constructor(element) {
        this.element = element;
        this.container = null;
        this.sectionWrappers = null;
        this.observer = null;
        this.threshold = 0.1;
        this.classList = {
            animatedSectionClass: 'js-animated-section',
            animatedLiClass: 'js-animated-li',
            fadeInBottomClass: 'js-fade-in-bottom',
            fadeInRightClass: 'js-fade-in-right',
            listsSelectors: 'ol, ul',
        };

        // Bindings
        this.$handleIntersection = this.handleIntersection.bind(this)

        this.init();
    }

    init() {
        const { animatedSectionClass } = this.classList;

        this.container = document.getElementById(`${this.element}`);
        this.sectionWrappers = document.querySelectorAll(`.${animatedSectionClass}`);

        this.observer = new IntersectionObserver(this.$handleIntersection, {
            root: this.container,
            threshold: this.threshold,
        });

        this.sectionWrappers.forEach(wrapper => {
            this.observer.observe(wrapper);
        });
    }

    handleIntersection(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                this.animateSection(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }

    animateSection(section) {
        const { fadeInBottomClass, listsSelectors } = this.classList;
        const list = section.querySelector(listsSelectors);

        section.classList.add(fadeInBottomClass);

        if (list) {
            this.animateList(list);
        }
    }

    animateList(list) {
        const { animatedLiClass, fadeInRightClass } = this.classList;
        const liArray = list.querySelectorAll(`.${animatedLiClass}`);

        liArray.forEach(li => {
            li.classList.add(fadeInRightClass);
        });
    }
}
